import React from "react";
import { Box, Divider } from "@mui/material";
import InnerFrame from "../shared/InnerFrame";
import SkillRow from "./SkillRow";

export default function SkillCard({
  parentSkill,
  childSkills,
  onParentLevelChange,
  onChildLevelChange,
}) {
  if (!parentSkill) return null;
  return (
    <InnerFrame
      sx={{
        p: { xs: 2.5, sm: 5 },
        width: "100%",
        maxWidth: "900px",
        mx: 0,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 0, sm: 3 } }}>
        <SkillRow
          displayName={parentSkill.displayName}
          experienceLabel={parentSkill.experienceLabel}
          levelValue={parentSkill.levelValue}
          onChangeLevel={onParentLevelChange}
        />

        {childSkills.length > 0 && <Divider sx={{ my: 1 }} />}

        {childSkills.map((child) => (
          <Box sx={{ pl: { xs: 3, sm: 0 }, pt: { xs: 2.5, sm: 0 } }}>
            <SkillRow
              key={child.recordId}
              displayName={child.displayName}
              experienceLabel={child.experienceLabel}
              levelValue={child.levelValue}
              isChild
              onChangeLevel={(value) =>
                onChildLevelChange(child.recordId, value)
              }
            />
          </Box>
        ))}
      </Box>
    </InnerFrame>
  );
}